
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqA89QvR_45KiOIBzu77djuf8FIuaS5Oz9yqlhy5UTeS85sMeta } from "/codebuild/output/src159980740/src/src/pages/faq.vue?macro=true";
import { default as menu8ckjPPOUIalqF5_45jG8dwZ_45TJ9ttur7YpWxdwtHuRtacMeta } from "/codebuild/output/src159980740/src/src/pages/menu.vue?macro=true";
import { default as indextlZ0YloiQLTRxfMXxfBdXZnVLHI_tYtuMxyerC6FXk0Meta } from "/codebuild/output/src159980740/src/src/pages/index.vue?macro=true";
import { default as contact8WEmB1JAj1PMgTeudwXNtFMVzTHTuikYhXHkei74s7QMeta } from "/codebuild/output/src159980740/src/src/pages/contact.vue?macro=true";
import { default as tutorialevNBuK6JSQogkNc8UMeu3Uh3rKZjAMsF6YU4KmsjkkMMeta } from "/codebuild/output/src159980740/src/src/pages/tutorial.vue?macro=true";
import { default as agreement_LPFRApz_PjReeyFgS4dTzHGDwQ9nddRSRJuoSgugmAMeta } from "/codebuild/output/src159980740/src/src/pages/agreement.vue?macro=true";
import { default as about_45passnvbhKTJbFhJTI770OT0RTNM6FjaISwSoEKiDyzIFkYYMeta } from "/codebuild/output/src159980740/src/src/pages/about-pass.vue?macro=true";
import { default as indexGJufLiuXH7dQXzRTvI4UOkq3bjArwm8dhPmYGlrkTC0Meta } from "/codebuild/output/src159980740/src/src/pages/card/index.vue?macro=true";
import { default as _91id_937DsFilf6ou8SQScF1mXPCxOEXLjL5sZYWf_xga8FQwAMeta } from "/codebuild/output/src159980740/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceiUpMorEf75m_45M3jpSrtTtruwMjsBkaEkbw9ZopaUR3YMeta } from "/codebuild/output/src159980740/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93X2672hGpmtZY1y1r9bemtPMf0jXwCYXZKcErrjZVI_45MMeta } from "/codebuild/output/src159980740/src/src/pages/notice/[id].vue?macro=true";
import { default as indexHLxIFyXIC3fzsnT58_455_45x1_45W39nGMM_ZHW3Y_EPeeggMeta } from "/codebuild/output/src159980740/src/src/pages/coupon/index.vue?macro=true";
import { default as indexTbKBT_I_tKD0Bgvp3JKjI5v1IsF6FsjEjCSm3FUcKPEMeta } from "/codebuild/output/src159980740/src/src/pages/mypage/index.vue?macro=true";
import { default as indexdZG1rDVvW2apesBnuPgkaxEklnEud3RHy1ESqnOaoJYMeta } from "/codebuild/output/src159980740/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93cvkCL6HCTSARrWraCRsowHF_45NVLPEWT6XF9xP_45RkIJ4Meta } from "/codebuild/output/src159980740/src/src/pages/parking/[id].vue?macro=true";
import { default as indexOUBjvng1BQYC_45ZhG66p99pI73E1pVDBd70X0FrNPyxUMeta } from "/codebuild/output/src159980740/src/src/pages/history/index.vue?macro=true";
import { default as indexX9B8ALjNyiAG90qslNT4s10_45lJR4Q2HwGGSd0d_45XvWQMeta } from "/codebuild/output/src159980740/src/src/pages/monthly/index.vue?macro=true";
import { default as indexwtnWnRLj0E9LQvk59faABswDjntbz3QwQ0XtfEBvA2IMeta } from "/codebuild/output/src159980740/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexDTyMpe61tj38wcOluyJ4ecWKVTnbOP4XikRylvO071kMeta } from "/codebuild/output/src159980740/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavi8AgYODSb_5gAjKZDd29xbCF6dgdnny_woadWPlXNrGsMeta } from "/codebuild/output/src159980740/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editxBCpKmmoNZT5nZLqke4tHw_gwVSmZ7Ftz8kMAX8iQWkMeta } from "/codebuild/output/src159980740/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementbBHM7ZYc9puYaaFrrip5eRitjR6PMsqH5r9E1_457yQjwMeta } from "/codebuild/output/src159980740/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexgiG7r_45KgOq88kSZSfGizUNyrgTDly2_45vHBeXpTZ3Y1oMeta } from "/codebuild/output/src159980740/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dInxMJayGFc8sEeg5e7KccbvvDcRCBZRj0Mv0Y6viKzUMeta } from "/codebuild/output/src159980740/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmRIVkAXmMeUPAgRggvuG9BKrvz_32FUAUIWZOHZntLw0Meta } from "/codebuild/output/src159980740/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexsAzYnJ6t5uErfE__bdgms6vbl8gq1bFEdRJ3qzhODmcMeta } from "/codebuild/output/src159980740/src/src/pages/card/create/index.vue?macro=true";
import { default as indexzikr_udiMIYw6BlX5gpRBGH7n7D9a97h0q0PJJ4K8FEMeta } from "/codebuild/output/src159980740/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmNzaTSPXMe3VtsTmufR2s2OUypDl4_45mD8v_rldn4vh6YMeta } from "/codebuild/output/src159980740/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmJuPidXP8Xaf9KZswlI_45Flcl1PCKYdnCEknzTqny071YMeta } from "/codebuild/output/src159980740/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeC9oAZiVcU0SDl7v5LirW0_45u_sPEBZqPG16ySwKp0yJsMeta } from "/codebuild/output/src159980740/src/src/pages/membership/complete.vue?macro=true";
import { default as registeroA25jjkSK8g3_GFUxXKNb8vlGlIG0ylPAZC57zLuOuUMeta } from "/codebuild/output/src159980740/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93DUlA43d_45BLS7u4RArIA7ge5jEKpe0XW8IPFwjPE_hJgMeta } from "/codebuild/output/src159980740/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmYm5tNlOOvizjp8fYZ_wslxE3_Vm_MXEFOkiPzlR0E5UMeta } from "/codebuild/output/src159980740/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93y9Ix8n7qfoD_5ZSqiOqmuE6U2_45r9Flzpnyez1yLkDVoMeta } from "/codebuild/output/src159980740/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexgjmLxIIG2K2rxKnRswzan8a_45r9B8wTNR3IpMk7ICgJQMeta } from "/codebuild/output/src159980740/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codelqmINX_45AFo5_R4xzl7YXEJA9HUB4V7FxC_n2DZYH50gMeta } from "/codebuild/output/src159980740/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45code537zw_W1R5sW_i0UjRSB7JJVTKU1DDhRiQ98jmfyjD8Meta } from "/codebuild/output/src159980740/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeU_45bfHMnFiZ1sPnJXDPDChTPhbTqD8rdYEbpqcP5EeRYMeta } from "/codebuild/output/src159980740/src/src/pages/contact-form/complete.vue?macro=true";
import { default as register04iMHMTyqoQmkzxmuXiwgIAzFsafTlSUQEYdvNzYGU4Meta } from "/codebuild/output/src159980740/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeoDGvJ1F02G3_45IUo0DX33ajk9Jxg1hGNZaA0t42MvKgQMeta } from "/codebuild/output/src159980740/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexv3o9Hh5gh81uxZ55uzf02JwNPkT47Yq69RwqN2eCzx0Meta } from "/codebuild/output/src159980740/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmKm5GVnDc_ERirsWAjHJ6H1lIXZVryZXgaO7SbhIpUR4Meta } from "/codebuild/output/src159980740/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeDtiG5N8IRpcyU7NjnAuWNZo0kCNBTgUhJiJVR_AuonwMeta } from "/codebuild/output/src159980740/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexOkcR8_1_45AOvV4S2bBnrz2bDfkSG2Zk4eR4aN8YC0xJQMeta } from "/codebuild/output/src159980740/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93jwkFDbtEhTAxjrLsYwfIPEtnIhXSgy7Hivee0oZEXD0Meta } from "/codebuild/output/src159980740/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeUDGfbt0ERamkA_RrQCA2yd6e8fO_KPyzTIdHhwLVeWwMeta } from "/codebuild/output/src159980740/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasY0uIInDibugR_459xdzNBrZIvqzCXe9Br5vmIrzQkwNCUMeta } from "/codebuild/output/src159980740/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleQ_45B4kVL8C_45tW_JprxPVUZ81nJeNC9UAxvF_45fLWI5hH4Meta } from "/codebuild/output/src159980740/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailNaMDCeYsya9XYknlkKWxqsCc4oDpLOD7bphA94fXpmkMeta } from "/codebuild/output/src159980740/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmDpfP_NPB2ipBsrhW94nc4fuj79DogK8JR64IjbEss5QMeta } from "/codebuild/output/src159980740/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consenth1_sTKDv0w6jeB9Ns6089yX7eEkhXlKZoTL1O7nTNtUMeta } from "/codebuild/output/src159980740/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmwkxdPLwNIO8CnOTpz_45rUldDTB4OTlOhjYulr9OXjSrgMeta } from "/codebuild/output/src159980740/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedate0iUW45NBkIahjgb6M8Kh3hjz8BM7FnCKEy_45qqOLy5zYMeta } from "/codebuild/output/src159980740/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeEnexWjLTKvvlOQZmoY_45GJuJ43SsQT8rGXXz9qT39F4QMeta } from "/codebuild/output/src159980740/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45code0zH_I43d2CntWnFZC1pRULQW_45vjkNG5z0VkaYqGePm8Meta } from "/codebuild/output/src159980740/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordpUh2wG0H9dB221IadcYBCePLw8ALD6WBuP_SyLvqyEoMeta } from "/codebuild/output/src159980740/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliaseuCldU5F37f6679f6ANoxlecQTGc0dhzpUw_tjZxzHsMeta } from "/codebuild/output/src159980740/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerTFpVUS0T1NSFv4ecXln40HDlW50_cgLgsZFX_453dErh0Meta } from "/codebuild/output/src159980740/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45code8BU75PK6pPbtijTcQ2XKQ_45zecNa7giAT9g7GrIPeJ2EMeta } from "/codebuild/output/src159980740/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexzNSE12KkVK28lgDAVFJOrw7p_45aUPWajHwKiFuYCf9nkMeta } from "/codebuild/output/src159980740/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexnO4YGgUtUSfuB14PW3O1UIuec6IjcKiayv_D5YskzFgMeta } from "/codebuild/output/src159980740/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexB5bbWBSeX2APRGjKx99rWyee_CQyHRrXOp6TOYfu0NkMeta } from "/codebuild/output/src159980740/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexSOrCO8SiTzZv_45qhaJdcaFf4UIAk85Kf7qxD_PUuo0WYMeta } from "/codebuild/output/src159980740/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateEQFBCqj4iAac1g_45jNImoGJ64BxIYPtKgn43gLoIrsn4Meta } from "/codebuild/output/src159980740/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as complete2T_Sh1QCJPYsLclcD980ji_45huvFYCm_45yWLUHTPd8UvsMeta } from "/codebuild/output/src159980740/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmJcf3x_45dkQgcj5ZKHXfe1BZ_43HHXNOp3QJyNHqUJaLgMeta } from "/codebuild/output/src159980740/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as index62u5x2X39czc8BtMAJ6YACZ068ifYLviU5goXu95_45wQMeta } from "/codebuild/output/src159980740/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as complete_456qnLg0SbydxQaIlXWKwj5Ne98WHTkA0g_cdfst1AtEMeta } from "/codebuild/output/src159980740/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updatebHrP7jNxiaqASR5Assg_45nSmgotZq_45DblmQuRvqZIoOMMeta } from "/codebuild/output/src159980740/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexPkBdnr9jLCf632XdNMe0CLDqHaFs5dYQ3eeXVwi_uPwMeta } from "/codebuild/output/src159980740/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexJgsg6pMRVjNTShKYPp7xAYuAH_xSanbusrv6UMkwn5wMeta } from "/codebuild/output/src159980740/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as complete8DQ63ika3pyq_45THADXLOrvQ7MwtnxhkrlpoAf1rrTTgMeta } from "/codebuild/output/src159980740/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexMc3Rr1iI9__45j38I7f6wICPYSekAt8Or5tQ_45tjTHrK9wMeta } from "/codebuild/output/src159980740/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codepVYeOcgxvriaVX6JsTcPQZsQwtFjZA6ePNGRHK5PMQcMeta } from "/codebuild/output/src159980740/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as index5q24YUTWp7RSEwVYnWGTySSjNB3P4mE3CXs6Do25MlMMeta } from "/codebuild/output/src159980740/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexHs_45Ap8OhTeF3b_45ALJWRkJXzj64CDcD_45n4DLNwPQyTDgMeta } from "/codebuild/output/src159980740/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexYS4o0f_45kiiapJRoMjc5HuTITxLOS3LiGa3Ugv_45rSteUMeta } from "/codebuild/output/src159980740/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateEHxFoyEZMUqrGHsjnRFfmkf35qM0egdAwnfLy2pukxIMeta } from "/codebuild/output/src159980740/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirme77xGtPiBTI9wi7fgVs3txskrh56LIAg71vsHK1YdoMMeta } from "/codebuild/output/src159980740/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src159980740/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menu8ckjPPOUIalqF5_45jG8dwZ_45TJ9ttur7YpWxdwtHuRtacMeta || {},
    component: () => import("/codebuild/output/src159980740/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indextlZ0YloiQLTRxfMXxfBdXZnVLHI_tYtuMxyerC6FXk0Meta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src159980740/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src159980740/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src159980740/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src159980740/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src159980740/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src159980740/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src159980740/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src159980740/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src159980740/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexHLxIFyXIC3fzsnT58_455_45x1_45W39nGMM_ZHW3Y_EPeeggMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src159980740/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src159980740/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src159980740/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src159980740/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexOUBjvng1BQYC_45ZhG66p99pI73E1pVDBd70X0FrNPyxUMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src159980740/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src159980740/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexwtnWnRLj0E9LQvk59faABswDjntbz3QwQ0XtfEBvA2IMeta || {},
    component: () => import("/codebuild/output/src159980740/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexDTyMpe61tj38wcOluyJ4ecWKVTnbOP4XikRylvO071kMeta || {},
    component: () => import("/codebuild/output/src159980740/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src159980740/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src159980740/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src159980740/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src159980740/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src159980740/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src159980740/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexsAzYnJ6t5uErfE__bdgms6vbl8gq1bFEdRJ3qzhODmcMeta || {},
    component: () => import("/codebuild/output/src159980740/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src159980740/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmNzaTSPXMe3VtsTmufR2s2OUypDl4_45mD8v_rldn4vh6YMeta || {},
    component: () => import("/codebuild/output/src159980740/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmJuPidXP8Xaf9KZswlI_45Flcl1PCKYdnCEknzTqny071YMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src159980740/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeC9oAZiVcU0SDl7v5LirW0_45u_sPEBZqPG16ySwKp0yJsMeta || {},
    component: () => import("/codebuild/output/src159980740/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registeroA25jjkSK8g3_GFUxXKNb8vlGlIG0ylPAZC57zLuOuUMeta || {},
    component: () => import("/codebuild/output/src159980740/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src159980740/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmYm5tNlOOvizjp8fYZ_wslxE3_Vm_MXEFOkiPzlR0E5UMeta || {},
    component: () => import("/codebuild/output/src159980740/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src159980740/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src159980740/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codelqmINX_45AFo5_R4xzl7YXEJA9HUB4V7FxC_n2DZYH50gMeta || {},
    component: () => import("/codebuild/output/src159980740/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45code537zw_W1R5sW_i0UjRSB7JJVTKU1DDhRiQ98jmfyjD8Meta || {},
    component: () => import("/codebuild/output/src159980740/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeU_45bfHMnFiZ1sPnJXDPDChTPhbTqD8rdYEbpqcP5EeRYMeta || {},
    component: () => import("/codebuild/output/src159980740/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: register04iMHMTyqoQmkzxmuXiwgIAzFsafTlSUQEYdvNzYGU4Meta || {},
    component: () => import("/codebuild/output/src159980740/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src159980740/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src159980740/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmKm5GVnDc_ERirsWAjHJ6H1lIXZVryZXgaO7SbhIpUR4Meta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src159980740/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeDtiG5N8IRpcyU7NjnAuWNZo0kCNBTgUhJiJVR_AuonwMeta || {},
    component: () => import("/codebuild/output/src159980740/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexOkcR8_1_45AOvV4S2bBnrz2bDfkSG2Zk4eR4aN8YC0xJQMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src159980740/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src159980740/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeUDGfbt0ERamkA_RrQCA2yd6e8fO_KPyzTIdHhwLVeWwMeta || {},
    component: () => import("/codebuild/output/src159980740/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src159980740/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleQ_45B4kVL8C_45tW_JprxPVUZ81nJeNC9UAxvF_45fLWI5hH4Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src159980740/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailNaMDCeYsya9XYknlkKWxqsCc4oDpLOD7bphA94fXpmkMeta || {},
    component: () => import("/codebuild/output/src159980740/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmDpfP_NPB2ipBsrhW94nc4fuj79DogK8JR64IjbEss5QMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src159980740/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consenth1_sTKDv0w6jeB9Ns6089yX7eEkhXlKZoTL1O7nTNtUMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src159980740/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmwkxdPLwNIO8CnOTpz_45rUldDTB4OTlOhjYulr9OXjSrgMeta || {},
    component: () => import("/codebuild/output/src159980740/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src159980740/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeEnexWjLTKvvlOQZmoY_45GJuJ43SsQT8rGXXz9qT39F4QMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src159980740/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45code0zH_I43d2CntWnFZC1pRULQW_45vjkNG5z0VkaYqGePm8Meta || {},
    component: () => import("/codebuild/output/src159980740/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordpUh2wG0H9dB221IadcYBCePLw8ALD6WBuP_SyLvqyEoMeta || {},
    component: () => import("/codebuild/output/src159980740/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src159980740/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerTFpVUS0T1NSFv4ecXln40HDlW50_cgLgsZFX_453dErh0Meta || {},
    component: () => import("/codebuild/output/src159980740/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45code8BU75PK6pPbtijTcQ2XKQ_45zecNa7giAT9g7GrIPeJ2EMeta || {},
    component: () => import("/codebuild/output/src159980740/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src159980740/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src159980740/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src159980740/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src159980740/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src159980740/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src159980740/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src159980740/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src159980740/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src159980740/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src159980740/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src159980740/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src159980740/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src159980740/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src159980740/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src159980740/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src159980740/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src159980740/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src159980740/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src159980740/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src159980740/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]